import { render, staticRenderFns } from "./BhBackground.vue?vue&type=template&id=870a11b6"
import script from "./BhBackground.vue?vue&type=script&lang=js"
export * from "./BhBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports